<template>
  <div class="exchangeBaseInfo">
    <div v-loading="loading" class="rj-page-card">
      <div class="rj-page-card__title">
        退货合同
      </div>
      <div class="rj-page-card__content">
        <el-form ref="form" :model="info" :rules="rules" class="baseInfoForm">
          <div class="rj-row">
            <div class="rj-col-66">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  项目名称：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rprojectName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  订单日期：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rcreatedTime }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  电子商务合同编号：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rnewContractNum }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  原订单合同编号：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.roldContractNum }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  订单分类：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rorderType }}
                </div>
              </div>
            </div>
            <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  供货单位(甲方)：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.supplyUnit }}
                </div>
              </div>
            </div>
            <div class="rj-col-66">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  供货单位地址：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.supplyAddress }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  供货单位电话(甲方)：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.supplyPhone }}
                </div>
              </div>
            </div>
            <div class="rj-col-66">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  订货单位(乙方)：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rorderUnitName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  订货单位电话(乙方)：
                </div>
                <div class="rj-baseinfo__item">
                  <el-input v-model="infoAll.rorderUnitTel" placeholder="请输入订货单位电话" />
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  最终客户：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rfinalCustomerName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  客户签约类型：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rdistributorName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  区域：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rsalesArea }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  首级集成商名称：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rintegratorName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  首级集成商类型：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rintegratorSignType }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  区域商务专员：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rassistantName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  售前名称：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rpreSalesPersonName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  销售名称：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rsalesPersonName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  部门：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rsalesPersonDeptName }}
                </div>
              </div>
            </div>
            <div v-if="this.$route.query.contratType==='齐套不提货撤单'">
              <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    实际打款金额：
                  </div>
                  <div class="rj-baseinfo__item">
                    {{ infoAll.roldAssignedAmount }}
                  </div>
                </div>
              </div>
              <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    扣减金额：
                  </div>
                  <div class="rj-baseinfo__item">
                    {{ infoAll.rdeductionAmount }}
                  </div>
                </div>
              </div>
              <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    费用扣减方式：
                  </div>
                  <div class="rj-baseinfo__item">
                    <span v-if="infoAll.rdeductionType === 0">无</span>
                    <span v-if="infoAll.rdeductionType === 1">代理商支付</span>
                    <span v-if="infoAll.rdeductionType === 2">扣减销售工资</span>
                    <span v-if="infoAll.rdeductionType === 3">扣减代理商返利</span>
                    <span v-if="infoAll.rdeductionType === 4">扣减阿米巴费用</span>
                  </div>
                  <template v-if="infoAll.rdeductionType ===3">
                    使用金额: {{ infoAll.rebateAmount }} 元
                    <!-- eslint-disable-next-line vue/require-component-is -->
                    <component
                      v-bind="dialogNode"
                      @chooesSuccess="chooseRebateSuccess"
                    />
                  </template>
                </div>
              </div>
              <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    退款方式：
                  </div>
                  <div class="rj-baseinfo__item">
                    <el-radio v-model="infoAll.rrefundMethod" :label="1">
                      实际退款
                    </el-radio>
                    <el-radio v-model="infoAll.rrefundMethod" :label="2">
                      用于其他项目
                    </el-radio>
                  </div>
                </div>
              </div>
              <!-- <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">实际退还金额：</div>
                  <div class="rj-baseinfo__item">{{ infoAll.rrefundAmount }}</div>
                </div>
              </div> -->
              <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    退还返利金额：
                  </div>
                  <div class="rj-baseinfo__item">
                    {{ infoAll.rrefundRebate }}
                  </div>
                </div>
              </div>
              <div v-if="infoAll.rrefundMethod === 1">
                <div class="rj-col-3">
                  <div class="rj-baseinfo">
                    <div class="rj-baseinfo__label">
                      收款单位：
                    </div>
                    <div class="rj-baseinfo__item">
                      <el-input v-model="infoAll.rcompanyName" placeholder="请输入收款单位" />
                    </div>
                  </div>
                </div>
                <div class="rj-col-66">
                  <div class="rj-baseinfo">
                    <div class="rj-baseinfo__label">
                      银行账号：
                    </div>
                    <div class="rj-baseinfo__item">
                      <el-input v-model="infoAll.rbankNum" placeholder="请输入银行账号" />
                    </div>
                  </div>
                </div>
                <div class="rj-col-1">
                  <div class="rj-baseinfo">
                    <div class="rj-baseinfo__label">
                      开户行：
                    </div>
                    <div class="rj-baseinfo__item">
                      <el-input v-model="infoAll.openBankName" placeholder="请输入开户行" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="rj-col-1">
                <el-form-item prop="rsupplementalTerm" label="补充条款:">
                  <el-input v-model.trim="form.rsupplementalTerm" type="textarea" :rows="3" placeholder="请输入补充条款内容" />
                </el-form-item>
              </div>
              <div class="rj-col-1">
                <el-form-item prop="remarks" label="备注说明:">
                  <el-input v-model.trim="form.remarks" type="textarea" :rows="3" placeholder="请输入备注说明" />
                </el-form-item>
              </div>
            </div>
            <div v-if="this.$route.query.contratType==='产品缺货或停产'">
              <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    实际打款金额：
                  </div>
                  <div class="rj-baseinfo__item">
                    {{ infoAll.roldAssignedAmount }}
                  </div>
                </div>
              </div>
              <!-- <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">实际退还金额：</div>
                  <div class="rj-baseinfo__item">{{ infoAll.rrefundAmount }}</div>
                </div>
              </div> -->
              <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    退还返利金额：
                  </div>
                  <div class="rj-baseinfo__item">
                    {{ infoAll.rrefundRebate }}
                  </div>
                </div>
              </div>
              <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    退款方式：
                  </div>
                  <div class="rj-baseinfo__item">
                    <el-radio v-model="infoAll.rrefundMethod" :label="1">
                      实际退款
                    </el-radio>
                    <el-radio v-model="infoAll.rrefundMethod" :label="2">
                      用于其他项目
                    </el-radio>
                  </div>
                </div>
              </div>
              <div v-if="infoAll.rrefundMethod === 1">
                <div class="rj-col-3">
                  <div class="rj-baseinfo">
                    <div class="rj-baseinfo__label">
                      收款单位：
                    </div>
                    <div class="rj-baseinfo__item">
                      <el-input v-model="infoAll.rcompanyName" placeholder="请输入收款单位" />
                    </div>
                  </div>
                </div>
                <div class="rj-col-3">
                  <div class="rj-baseinfo">
                    <div class="rj-baseinfo__label">
                      银行账号：
                    </div>
                    <div class="rj-baseinfo__item">
                      <el-input v-model="infoAll.rbankNum" placeholder="请输入银行账号" />
                    </div>
                  </div>
                </div>
                <div class="rj-col-1">
                  <div class="rj-baseinfo">
                    <div class="rj-baseinfo__label">
                      开户行：
                    </div>
                    <div class="rj-baseinfo__item">
                      <el-input v-model="infoAll.openBankName" placeholder="请输入开户行" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="rj-col-1">
                <el-form-item prop="rsupplementalTerm" label="补充条款:">
                  <el-input v-model.trim="form.rsupplementalTerm" type="textarea" :rows="3" placeholder="请输入补充条款内容" />
                </el-form-item>
              </div>
              <div class="rj-col-1">
                <el-form-item prop="remarks" label="备注说明:">
                  <el-input v-model.trim="form.remarks" type="textarea" :rows="3" placeholder="请输入备注说明" />
                </el-form-item>
              </div>
            </div>

            <div v-if="this.$route.query.contratType!=='齐套不提货撤单' &&this.$route.query.contratType!=='产品缺货或停产'">
              <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    实际打款金额：
                  </div>
                  <div class="rj-baseinfo__item">
                    {{ infoAll.roldAssignedAmount }}
                  </div>
                </div>
              </div>
              <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    扣减金额：
                  </div>
                  <div class="rj-baseinfo__item">
                    {{ infoAll.rdeductionAmount }}
                  </div>
                </div>
              </div>
              <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    费用扣减方式：
                  </div>
                  <div class="rj-baseinfo__item">
                    <span v-if="infoAll.rdeductionType === 0">无</span>
                    <span v-if="infoAll.rdeductionType === 1">代理商支付</span>
                    <span v-if="infoAll.rdeductionType === 2">扣减销售工资</span>
                    <span v-if="infoAll.rdeductionType === 3">扣减代理商返利</span>
                    <span v-if="infoAll.rdeductionType === 4">扣减阿米巴费用</span>
                  </div>
                </div>
              </div>
              <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    退款方式：
                  </div>
                  <div class="rj-baseinfo__item">
                    <el-radio v-model="infoAll.rrefundMethod" :label="1">
                      实际退款
                    </el-radio>
                    <el-radio v-model="infoAll.rrefundMethod" :label="2">
                      用于其他项目
                    </el-radio>
                  </div>
                </div>
              </div>
              <!-- <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">实际退还金额：</div>
                  <div class="rj-baseinfo__item">{{ infoAll.rrefundAmount }}</div>
                </div>
              </div> -->
              <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    退还返利金额：
                  </div>
                  <div class="rj-baseinfo__item">
                    {{ infoAll.rrefundRebate }}
                  </div>
                </div>
              </div>
              <div v-if="infoAll.rrefundMethod === 1">
                <div class="rj-col-3">
                  <div class="rj-baseinfo">
                    <div class="rj-baseinfo__label">
                      收款单位：
                    </div>
                    <div class="rj-baseinfo__item">
                      <el-input v-model="infoAll.rcompanyName" placeholder="请输入收款单位" />
                    </div>
                  </div>
                </div>
                <div class="rj-col-66">
                  <div class="rj-baseinfo">
                    <div class="rj-baseinfo__label">
                      银行账号：
                    </div>
                    <div class="rj-baseinfo__item">
                      <el-input v-model="infoAll.rbankNum" placeholder="请输入银行账号" />
                    </div>
                  </div>
                </div>
                <div class="rj-col-1">
                  <div class="rj-baseinfo">
                    <div class="rj-baseinfo__label">
                      开户行：
                    </div>
                    <div class="rj-baseinfo__item">
                      <el-input v-model="infoAll.openBankName" placeholder="请输入开户行" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="rj-col-1">
                <el-form-item prop="rsupplementalTerm" label="补充条款:">
                  <el-input v-model.trim="form.rsupplementalTerm" type="textarea" :rows="3" placeholder="请输入补充条款内容" />
                </el-form-item>
              </div>
              <div class="rj-col-1">
                <el-form-item prop="remarks" label="备注说明:">
                  <el-input v-model.trim="form.remarks" type="textarea" :rows="3" placeholder="请输入备注说明" />
                </el-form-item>
              </div>

              <!-- <div class="rj-col-1">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">选择文件：</div>
                <div class="rj-baseinfo__item">{{ infoAll.orderUnit }}</div>
                </div>
              </div> -->
            </div>
            <div class="rj-col-1">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  退票方式：
                </div>
                <!-- <div class="rj-baseinfo__item">{{ infoAll.rRefundInvoiceType }}</div> -->
                <div class="rj-baseinfo__item">
                  <el-radio v-model="infoAll.rrefundInvoiceType" :label="1">
                    退还原发票（寄送到锐捷公司）
                  </el-radio>
                  <el-radio v-model="infoAll.rrefundInvoiceType" :label="2">
                    提供红字信息表
                  </el-radio>
                  <el-radio v-model="infoAll.rrefundInvoiceType" :label="3">
                    不退票
                  </el-radio>
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  物流公司：
                </div>
                <div class="rj-baseinfo__item">
                  <!-- <el-form-item prop="projectName"> -->
                  <el-input v-model="infoAll.rlogisticsCompanyName" placeholder="请输入项目名称" />
                  <!-- </el-form-item> -->
                </div>
              </div>
            </div>
            <div class="rj-col-2">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  物流单号：
                </div>
                <div class="rj-baseinfo__item">
                  <!-- <el-form-item prop="setNoticeMail"> -->
                  <el-input v-model="infoAll.rlogisticsNum" placeholder="请输入物流单号" />
                  <!-- </el-form-item> -->
                </div>
              </div>
            </div>
            <div class="rj-col-1">
              <el-form-item prop="rreceivingAddress" label="退票收件地址:">
                <el-input v-model.trim="infoAll.rreceivingAddress" type="textarea" :rows="3" placeholder="请输入退票收件地址" />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getEditRebateUsedList,
  getRebateSummaryAgentInfo
} from '@/API';
import rebateUse from '../../../Chief/contract/rabateUse.vue';
import rebateUsedList from '../../../Chief/contract/rebateUsedList.vue';
// import Collapse from '@/components/Collapse';
/* eslint-disable */
export default {
  data () {
    return {
      loading: false,
      form: {},
      rules: {},
      infoAll:this.info,
       dialogNode: {
        is: '',
        allow: 123,//当前合同最大返利金额
        availableRebateAmount: 0,
        rebateUsedList: []
      }
    };
  },
    components: {
    rebateUse,
    rebateUsedList
  },

  props: {
    info: {
      type: Object,
      default: () => { return {}; }
    }
  },
    watch:{
    info (val) {
      this.infoAll = val;
      this.dialogNode.allow = this.infoAll.rdeductionAmount;
      this.getEditRebateUsedList();
    },
  },
  methods:{
    chooseRebateSuccess (val) {
      // 赋值过程toFixed();
      this.infoAll.rebateAmount = val.total;
      this.dialogNode.rebateUsedList = val.list;
    },
    // 返利 接口
    getEditRebateUsedList () {
      getEditRebateUsedList({ contractNum: this.$route.query.rnewContractNum })
      // getEditRebateUsedList({ contractNum: '150221122800300' })
        .then((res) => {
          let json = res.data;
          if (json.status === '200') {
            if (json.data.length) {
              this.dialogNode.rebateUsedList = json.data;
              this.dialogNode.is = 'rebate-used-list';
            } else {
              this.dialogNode.is = 'rebate-use';
            }
          }
        })
        .catch(() => { });
      getRebateSummaryAgentInfo({ contractNum: this.$route.query.rnewContractNum })
      // getRebateSummaryAgentInfo({ contractNum: '150221122800300' })
        .then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.dialogNode.availableRebateAmount = json.data.availableAmount;
          }
        })
        .catch(() => { });
    }
  },
};
</script>

<style lang='scss'>
.exchangeBaseInfo{
 .rj-col-66 {
    float: left;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 66.6666%;
}
}

</style>
